define('pages/media/upload_modal_view',[
  'backbone',
  'jquery',
  '_',
  'text!./upload_modal_template.html'
], function (Backbone, $, _,
             modal_template) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {
      _.extend(this, opts);

      this.render();
    },

    tagName: 'div',
    className: 'upload-modal',
    template: _.template(modal_template),

    render: function () {
      this.$el.html(this.template());
      return this;
    },

    remove: function () {
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    }
  });
  return View;
});

